import React, { useState } from 'react';
import { Boxes, BookOpen, History, BarChart3 } from 'lucide-react';
import { SuppliesPanel } from './SuppliesPanel';
import { RecipesPanel } from './RecipesPanel';
import { MovementsPanel } from './MovementsPanel';
import { ReportPanel } from './ReportPanel';

const VIEWS = [
  { key: 'insumos', label: 'Insumos', icon: Boxes },
  { key: 'recetas', label: 'Recetas', icon: BookOpen },
  { key: 'movimientos', label: 'Movimientos', icon: History },
  { key: 'reporte', label: 'Reporte diario', icon: BarChart3 },
];

export const InventoryTab = ({ onChanged }) => {
  const [view, setView] = useState('insumos');
  return (
    <div className="space-y-4" data-testid="inventory-tab">
      <div className="flex flex-wrap gap-2">
        {VIEWS.map(({ key, label, icon: Icon }) => (
          <button
            key={key}
            onClick={() => setView(key)}
            data-testid={`inventory-view-${key}`}
            className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-semibold border transition-colors ${
              view === key ? 'bg-emerald-600 border-emerald-500 text-white' : 'border-gray-700 text-gray-400 hover:text-white'
            }`}
          >
            <Icon className="h-4 w-4" /> {label}
          </button>
        ))}
      </div>
      {view === 'insumos' && <SuppliesPanel onChanged={onChanged} />}
      {view === 'recetas' && <RecipesPanel onChanged={onChanged} />}
      {view === 'movimientos' && <MovementsPanel />}
      {view === 'reporte' && <ReportPanel />}
    </div>
  );
};
